// removed by extract-text-webpack-plugin
module.exports = {"ScreenXSMax":"(max-width: 767px)","ScreenSMMin":"(min-width: 768px)","ScreenMDMin":"(min-width: 992px)","ScreenLGMin":"(min-width: 1200px)","threeTileRecipeList":"G5bc4cd"};